import React from 'react';
import { WithStatelessDatasFetchingByParameters } from '../../../../../shared/hocs';
import { PaginatedListWithFilters } from '../../../../../shared/models';
import { LightProduct, SearchProducts } from '../../../../models';

import {
    InnerEnhancedFilterableProductEnhancerInputProps,
    InnerEnhancedFilterableProductProps,
} from './inner-enhanced-filterable-product-list-type';
import { InnerEnhancedFilterableProductListLoader } from './inner-enhanced-filterable-product-list-loader';

const enhancer = (
    Component: React.FC<InnerEnhancedFilterableProductProps>,
): React.FC<InnerEnhancedFilterableProductEnhancerInputProps> => {
    const InnerComponent: React.FC<InnerEnhancedFilterableProductEnhancerInputProps> = ({
        fetchProducts,
        ...rest
    }: InnerEnhancedFilterableProductEnhancerInputProps) => {
        const FetchingComponent = WithStatelessDatasFetchingByParameters<
            PaginatedListWithFilters<LightProduct>,
            InnerEnhancedFilterableProductProps,
            SearchProducts
        >(fetchProducts, InnerEnhancedFilterableProductListLoader, 'redirect', 'datas', ['id', 'filters'])(Component);
        return <FetchingComponent {...rest} filters={rest.filters} />;
    };

    return InnerComponent;
};

export default enhancer;
